import { extendTheme } from '@chakra-ui/react';

export default extendTheme({
  colors: {
    black: {
      50: 'var(--color-black-light)',
      100: 'var(--color-black-light)',
      200: 'var(--color-black-light)',
      300: 'var(--color-black-light)',
      400: 'var(--color-black-light)',
      500: 'var(--color-black)',
      600: 'var(--color-black-dark)',
      700: 'var(--color-black-dark)',
      800: 'var(--color-black-dark)',
      900: 'var(--color-black-dark)',
    },
    brand: {
      red: {
        50: 'var(--color-brand-red-light)',
        100: 'var(--color-brand-red-light)',
        200: 'var(--color-brand-red-light)',
        300: 'var(--color-brand-red-light)',
        400: 'var(--color-brand-red-light)',
        500: 'var(--color-brand-red)',
        600: 'var(--color-brand-red-darker)',
        700: 'var(--color-brand-red-darker)',
        800: 'var(--color-brand-red-darker)',
        900: 'var(--color-brand-red-darker)',
      },
      blue: {
        50: 'var(--color-brand-blue-light)',
        100: 'var(--color-brand-blue-light)',
        200: 'var(--color-brand-blue-light)',
        300: 'var(--color-brand-blue-light)',
        400: 'var(--color-brand-blue-light)',
        500: 'var(--color-brand-blue)',
        600: 'var(--color-brand-blue-dark)',
        700: 'var(--color-brand-blue-dark)',
        800: 'var(--color-brand-blue-dark)',
        900: 'var(--color-brand-blue-dark)',
      },
      yellow: {
        50: 'var(--color-brand-yellow-light)',
        100: 'var(--color-brand-yellow-light)',
        200: 'var(--color-brand-yellow-light)',
        300: 'var(--color-brand-yellow-light)',
        400: 'var(--color-brand-yellow-light)',
        500: 'var(--color-brand-yellow)',
        600: 'var(--color-brand-yellow-dark)',
        700: 'var(--color-brand-yellow-dark)',
        800: 'var(--color-brand-yellow-dark)',
        900: 'var(--color-brand-yellow-dark)',
      },
    },
    feedback: {
      success: {
        50: 'var(--color-success)',
        100: 'var(--color-success)',
        200: 'var(--color-success)',
        300: 'var(--color-success)',
        400: 'var(--color-success)',
        500: 'var(--color-success)',
        600: 'var(--color-success)',
        700: 'var(--color-success)',
        800: 'var(--color-success)',
        900: 'var(--color-success)',
      },
    },
  },
  shadows: { outline: '0 0 0 2px var(--color-brand-blue-light)' },
});
